import {
  SMS_DISCLOSURE_TEXT,
  splitDisclosureForRender,
  type SmsDisclosureVersion,
} from "../../constants/smsConsentDisclosures";

interface SmsDisclosureTextProps {
  version: SmsDisclosureVersion;
  className?: string;
}

/**
 * Renders an SMS consent disclosure from the canonical registry.
 *
 * Every consent surface MUST render through this component rather than inlining copy. The words
 * shown here are byte-identical to what `record_sms_consent` freezes into the append-only evidence
 * row, which is the whole point: the external audit found the booth displaying one disclosure while
 * the database recorded another. Link phrases are presented as anchors but their WORDS remain part
 * of the canonical string, so displayed text still equals stored text.
 */
export function SmsDisclosureText({
  version,
  className,
}: SmsDisclosureTextProps) {
  const segments = splitDisclosureForRender(version);
  return (
    <span className={className} data-disclosure-version={version}>
      {segments.map((segment, index) =>
        segment.href ? (
          <a
            key={index}
            href={segment.href}
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            {segment.text}
          </a>
        ) : (
          <span key={index}>{segment.text}</span>
        ),
      )}
    </span>
  );
}

/** Plain-text form, for anywhere a string (not JSX) is needed. */
export function smsDisclosurePlainText(version: SmsDisclosureVersion): string {
  return SMS_DISCLOSURE_TEXT[version];
}
